var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "1453 1455.95 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1453 1474.9a19 19 0 1 1 0 .1z",
    fill: "#f0f0f7",
    fillRule: "evenodd",
    "data-name": "Icon.BG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464 1475.999c0-3.9 3.1-7 7-7 1.601 0 3 .5 4.202 1.401l.9-.901-.802-.8c-.4-.4-.4-1 0-1.4a.968.968 0 0 1 1.4 0l3.001 3.001c.4.4.4 1 0 1.4-.2.2-.402.3-.7.3-.3 0-.501-.1-.701-.3l-.8-.8-.9.9c.9 1.199 1.4 2.6 1.4 4.199 0 3.9-3.1 7-7 7s-7-3.1-7-7Zm2.001 0c0 2.8 2.2 5.001 4.999 5.001 2.8 0 5.001-2.2 5.001-5.001 0-2.8-2.2-5-5.001-5-2.798 0-4.999 2.2-4.999 5Zm4 1v-4h2v2h2v2h-4Z",
    fill: "#b4b4c6",
    fillRule: "evenodd",
    "data-name": "time-countdown"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldIcon);
export default __webpack_public_path__ + "static/media/hold_icon.caedaae0d52a35e8c605de9a98eb12a3.svg";
export { ForwardRef as ReactComponent };